import UserError from './UserError.js'

export class SaveAdShareByEmailHitUserError extends UserError {}
